import { get, post } from "@/services/http/platformServer";

export interface QuantityInspectionCode {
    orderOriginalId: string;
    printCodeData?: {
        boxDTOList: [
            {
                boxId: number;
                boxName: string;
                boxNum: number;
            },
        ];
        channelAppId: string;
        deliveryId: string;
        deliveryName: string;
        backupDeliveryId: string;
        backupDeliveryName: string;
        embedGoodsMaterial: string;
        expressMerge: true;
        goodsDesc: string;
        goodsMainMaterial: string;
        goodsName: string;
        goodsNum: number;
        goodsPartsMaterial: string;
        inspectBaseId: string;
        inspectBaseName: string;
        inspectCode: string;
        inspectOrgId: string;
        inspectOrgName: string;
        inspectOrgShortName: string;
        merchantName: string;
        orderId: string;
        urgentOrder: true;
        printInfo: string;
    };
    error?: string;
}

export function getQuantityInspectionCode(shopId: number, orderOriginalIds: string[]) {
    return post<QuantityInspectionCode[]>(
        shopId,
        "/channel_shop/order/get_quality_inspection_code",
        { shopId, orderOriginalIds },
        { hideModal: true },
    );
}
